<div class="lpo-dialog-container">
  <div class="lpo-header-actions no-print" *ngIf="!isLoading && !showInitialChoice && !showUploadSection">
    <!-- Preview Mode Toolbar -->
    <ng-container *ngIf="data.mode === 'preview'">
      <button mat-raised-button color="primary" (click)="downloadPdf()" style="margin-right: 10px;">
        <mat-icon>download</mat-icon> Download
      </button>
      <button mat-raised-button color="primary" (click)="printPdf()" style="margin-right: 10px;">
        <mat-icon>print</mat-icon> Print
      </button>
      <div class="spacer"></div>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </ng-container>

    <!-- Edit Mode Toolbar -->
    <ng-container *ngIf="data.mode !== 'preview'">
      <button mat-icon-button (click)="onBackToChoice()"
        *ngIf="!isVendor && !data.booking.lpoGenerated && !data.booking.LPO">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="spacer"></div>

      <!-- Vendor Actions - Only show if LPO not yet approved, not awaiting consent, and NOT sample -->
      <ng-container *ngIf="
          isVendor &&
          !data.booking.lpoApproved &&
          !data.booking.awaitingCustomerPriceConsent &&
          !isSample
        ">
        <button mat-flat-button color="primary" (click)="approveLpo()" [disabled]="isSaving"
          style="margin-right: 10px; background-color: #28a745; color: white">
          <mat-icon>check</mat-icon> Approve LPO
        </button>
        <button mat-flat-button color="warn" (click)="rejectLpo()" [disabled]="isSaving" style="margin-right: 10px">
          <mat-icon>close</mat-icon> Reject LPO
        </button>
      </ng-container>

      <!-- Only show Save & Send if not approved AND NOT sample AND LPO not uploaded -->
      <button *ngIf="
          !data.booking.lpoApproved &&
          !isVendor &&
          !isSample &&
          !data.booking.LPO
        " mat-flat-button color="primary" (click)="confirmSaveLpo()" [disabled]="
          isSaving ||
          !consentGiven ||
          (!data.booking.LPO &&
            !(customerDetails?.signatureUrl || customerDetails?.signatureBase64))
        " style="margin-right: 10px">
        <mat-icon *ngIf="!isSaving">send</mat-icon>
        <mat-spinner *ngIf="isSaving" diameter="20"
          style="display: inline-block; margin-right: 5px; vertical-align: middle"></mat-spinner>
        {{ data.booking.lpoGenerated ? 'Update & Send' : 'Save & Send' }}
      </button>

      <!-- Show digital LPO actions only if LPO not uploaded -->
      <button *ngIf="data.booking.lpoGenerated" mat-raised-button color="primary" (click)="printPdf()" style="margin-right: 10px;">
        <mat-icon>print</mat-icon> Print
      </button>
      <button *ngIf="data.booking.lpoGenerated" mat-raised-button color="primary" (click)="downloadPdf()">
        <mat-icon>picture_as_pdf</mat-icon> Download PDF
      </button>

      <!-- Open Uploaded LPO directly in new tab -->
      <a *ngIf="data.booking.LPO" mat-raised-button color="primary" [href]="data.booking.LPO" target="_blank" style="margin-right: 10px; text-decoration: none; display: inline-flex; align-items: center; justify-content: center; line-height: 36px; height: 36px; padding: 0 16px;">
        <mat-icon style="margin-right: 8px;">open_in_new</mat-icon> Open Document
      </a>
      <button mat-icon-button (click)="close()" aria-label="Close dialog" title="Close">
        <mat-icon>close</mat-icon>
      </button>
    </ng-container>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px;
      min-height: 300px;
    ">
    <div class="loader-wrapper">
      <mat-spinner diameter="40"></mat-spinner>
      <p style="margin: 8px 0 0 0; color: #64748b; font-size: 14px">
        Synchronizing latest booking details...
      </p>
    </div>
  </div>

  <!-- Initial Choice Screen -->
  <div class="initial-choice-container" *ngIf="!isLoading && showInitialChoice">
    <button mat-icon-button (click)="close()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>close</mat-icon>
    </button>

    <h2>Purchase Order (LPO)</h2>
    <p>
      Please upload your Local Purchase Order for this booking.
    </p>

    <div class="choice-buttons">
      <div class="choice-card" (click)="openUploadLpoDialog()">
        <div class="icon-wrapper">
          <mat-icon>upload_file</mat-icon>
        </div>
        <div class="text-wrapper">
          <span>Upload LPO</span>
          <small>Upload an existing PDF or image document from your device.</small>
        </div>
      </div>

      <!--
      <div class="choice-card" (click)="onGenerateClick()">
        <div class="icon-wrapper">
          <mat-icon>edit_note</mat-icon>
        </div>
        <div class="text-wrapper">
          <span>Generate Digital LPO</span>
          <small
            >Create a professional digital LPO using our smart template.</small
          >
        </div>
      </div>
      -->
    </div>
  </div>

  <!-- Upload Section -->
  <div class="initial-choice-container" *ngIf="!isLoading && showUploadSection">
    <button mat-icon-button (click)="onBackToChoice()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <h2>Upload LPO</h2>
    <p>
      Please select a PDF or image file of your Local Purchase Order to attach
      it to this booking.
    </p>

    <div class="upload-area-container">
      <div class="upload-drop-zone" [class.has-file]="selectedFile" (click)="openFilePicker()">
        <div class="upload-icon-circle">
          <mat-icon>{{
            selectedFile ? "description" : "picture_as_pdf"
            }}</mat-icon>
        </div>

        <div class="file-info" *ngIf="selectedFile">
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">{{ (selectedFile.size / 1024).toFixed(1) }} KB</span>
        </div>

        <p class="upload-prompt" *ngIf="!selectedFile">
          Drag & drop your file here or <strong>browse</strong>
        </p>

        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pdf,image/*" hidden />
      </div>

      <div class="upload-actions">
        <button mat-flat-button color="primary" class="confirm-upload-btn" [disabled]="!selectedFile || isSaving"
          (click)="uploadLPO()">
          <mat-icon *ngIf="!isSaving">cloud_upload</mat-icon>
          <mat-spinner diameter="20" *ngIf="isSaving" style="margin-right: 8px"></mat-spinner>
          {{ isSaving ? "Uploading..." : "Confirm & Upload" }}
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isLoading && !showInitialChoice && !showUploadSection">
    <div class="lpo-scroll-area">
      <!-- Case 1: Uploaded LPO file exists -->
      <ng-container *ngIf="data.booking.LPO && !data.booking.lpoGenerated; else digitalLpoTemplate">
        <div class="uploaded-lpo-preview" style="padding: 20px; text-align: center; background: white; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 500px;">
          <iframe *ngIf="!isImage(data.booking.LPO)" [src]="data.booking.LPO | safeUrl" style="width: 100%; height: 600px; border: none; border-radius: 4px;"></iframe>
          <img *ngIf="isImage(data.booking.LPO)" [src]="data.booking.LPO" style="max-width: 100%; max-height: 600px; object-fit: contain; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);" />
        </div>
      </ng-container>

      <!-- Case 2: Digital Generated LPO -->
      <ng-template #digitalLpoTemplate>
        <div id="lpo-content" class="lpo-paper">
        <!-- Header -->
        <div class="receipt-header">
          <div class="brand-info">
            <!-- Customer Logo -->
            <div class="customer-logo" *ngIf="
                customerDetails?.companyLogoBase64 ||
                customerLogoBase64 ||
                customerDetails?.logoUrl
              ">
              <img [src]="
                  customerDetails?.companyLogoBase64 ||
                  customerLogoBase64 ||
                  customerDetails?.logoUrl
                " alt="Company Logo" />
            </div>
            <div class="v-info">
              <!-- Customer Name (From) -->
              <h1>{{ customerDetails?.companyName || "Customer Name" }}</h1>
              <p>{{ customerDetails?.companyDetails || "Customer Address" }}</p>
              <p *ngIf="
                  customerDetails?.phoneNumber || data.booking.customer?.phone
                ">
                Phno:
                {{
                customerDetails?.phoneNumber || data.booking.customer?.phone
                }}
              </p>
              <p *ngIf="customerDetails?.telephoneNumber">
                Telephone: {{ customerDetails.telephoneNumber }}
              </p>
              <p>Email: {{ customerDetails?.email || "N/A" }}</p>
            </div>
          </div>
        </div>

        <!-- Centered Purchase Order Heading -->
        <div class="receipt-center-title" style="margin-top: 25px;">
          <h2>PURCHASE ORDER</h2>
          <p *ngIf="customerDetails?.lpoHeader" class="custom-header-text">
            {{ customerDetails.lpoHeader }}
          </p>
        </div>

        <!-- Body: Vendor and PO Info -->
        <div class="receipt-body">
          <!-- To Vendor -->
          <div class="section-box">
            <h3>TO</h3>
            <p>
              <strong>{{ vendorDetails?.displayName || "Vendor Name" }}</strong>
            </p>
            <p>{{ vendorDetails?.address || "Vendor Address" }}</p>
            <p>
              Phone: {{ vendorDetails?.phoneNumber }} <br />
              Email: {{ vendorDetails?.emailid }}
            </p>
          </div>

          <!-- PO Number and Date -->
          <div class="section-box align-right">
            <h3>Purchase Order Details</h3>
            <p class="ref-no">
              PO No: PO-{{ data.booking.id.slice(-6).toUpperCase() }}
            </p>
            <p class="date">Date: {{ lpoDate | date: "dd MMM yyyy" }}</p>
          </div>
        </div>

        <!-- Booking Details Section -->
        <div class="receipt-body no-margin">
          <div class="section-box full-width">
            <!-- Booking Details Section -->
            <div class="receipt-body no-margin">
              <div class="section-box full-width">
                <h3>BOOKING DETAILS</h3>

                <table class="details-table"
                  *ngIf="data.booking.equipments && data.booking.equipments.length > 0; else singleEquipmentHtml"
                  style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                  <thead>
                    <tr style="border-bottom: 2px solid #edf2f7; text-align: left; background: #f8fafc;">
                      <th style="padding: 10px; font-weight: 700; font-size: 13px; color: #475569;">Equipment</th>
                      <th style="padding: 10px; font-weight: 700; font-size: 13px; color: #475569;">Plate No</th>
                      <th style="padding: 10px; font-weight: 700; font-size: 13px; color: #475569;">Duration</th>
                      <th style="padding: 10px; font-weight: 700; font-size: 13px; color: #475569;">Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let eq of data.booking.equipments" style="border-bottom: 1px solid #edf2f7;">
                      <td style="padding: 10px; font-size: 13px; color: #1e293b;">
                        <strong>{{ eq.name || eq.customEquipmentName }}</strong>
                      </td>
                      <td style="padding: 10px; font-size: 13px; color: #64748b;">
                        {{ eq.plate_number || eq.customPlateNumber || '-' }}
                      </td>
                      <td style="padding: 10px; font-size: 13px; color: #64748b;">
                        {{ (eq.startDate?.toDate ? eq.startDate.toDate() : eq.startDate) | date: "dd MMM yyyy" }} to {{
                        (eq.endDate?.toDate ? eq.endDate.toDate() : eq.endDate) | date: "dd MMM yyyy" }}
                      </td>
                      <td style="padding: 10px; font-size: 13px; color: #64748b;">
                        {{ eq.location || eq.emirate || '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <ng-template #singleEquipmentHtml>
                  <table class="details-table grid-2x2">
                    <tr>
                      <td class="label">Equipment:</td>
                      <td class="value">
                        <strong>{{ data.booking.equipment?.name }}</strong> <br />
                        <span class="sub-text">
                          {{ data.booking.equipment?.brand }}
                          {{ data.booking.equipment?.model }}
                        </span>
                      </td>
                      <td class="label">Plate No:</td>
                      <td class="value">
                        {{ data.booking.equipment?.plate_number || "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="label">Duration:</td>
                      <td class="value">
                        <ng-container *ngIf="data.booking.customer?.priceType !== 'per_trip'">
                          {{
                          data.booking.customer?.startDate?.toDate()
                          | date: "dd MMM yyyy"
                          }}
                          to
                          {{
                          data.booking.customer?.endDate?.toDate()
                          | date: "dd MMM yyyy"
                          }}
                          <br />
                          ({{ duration }})
                        </ng-container>
                        <ng-container *ngIf="data.booking.customer?.priceType === 'per_trip'">
                          {{
                          data.booking.customer?.startDate?.toDate()
                          | date: "dd MMM yyyy"
                          }}
                          <br />
                          ({{ duration }})
                        </ng-container>
                      </td>
                      <td class="label">Location:</td>
                      <td class="value">
                        {{ data.booking.customer?.location || "-" }}
                      </td>
                    </tr>
                  </table>
                </ng-template>

              </div>
            </div>
          </div>
        </div>

        <!-- Financials -->
        <div class="receipt-financials">
          <table class="financial-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Rate / Type</th>
                <th class="text-right">Amount (AED)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngIf="data.booking.equipments && data.booking.equipments.length > 0; else singleFinancialRow">
                <tr *ngFor="let eq of data.booking.equipments">
                  <td>Rental Charges for {{ eq.name || eq.customEquipmentName }}</td>
                  <td>AED {{ eq.price | number: "1.0-0" }} / fixed</td>
                  <td class="text-right">{{ eq.price | number: "1.2-2" }}</td>
                </tr>
              </ng-container>
              <ng-template #singleFinancialRow>
                <tr>
                  <td>Rental Charges for {{ data.booking.equipment?.name }}</td>
                  <td>
                    AED {{ getEffectiveRate() | number: "1.0-0" }} /
                    {{ data.booking.customer?.priceType }}
                  </td>
                  <td class="text-right">
                    <div class="inline-edit-container">
                      <span *ngIf="!editingBase">{{
                        baseAmount | number: "1.2-2"
                        }}</span>
                      <input *ngIf="editingBase" type="number" [(ngModel)]="baseAmount" (blur)="editingBase = false"
                        (keyup.enter)="editingBase = false" class="inline-edit-input no-print" autofocus />
                      <button mat-icon-button *ngIf="
                          !isVendor && !editingBase && !data.booking.lpoApproved
                        " (click)="editingBase = true" class="no-print edit-icon-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
            <tfoot>
              <tr *ngIf="deliveryCharge > 0 || !data.booking.lpoApproved" class="adjustment-row">
                <td colspan="2">Transport Cost</td>
                <td class="text-right">
                  <div class="inline-edit-container">
                    <span *ngIf="!editingDelivery">{{
                      deliveryCharge | number: "1.2-2"
                      }}</span>
                    <input *ngIf="editingDelivery" type="number" [(ngModel)]="deliveryCharge"
                      (blur)="editingDelivery = false" (keyup.enter)="editingDelivery = false"
                      class="inline-edit-input no-print" autofocus />
                    <button mat-icon-button *ngIf="
                        !isVendor &&
                        !editingDelivery &&
                        !data.booking.lpoApproved
                      " (click)="editingDelivery = true" class="no-print edit-icon-btn">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <tr class="total-row">
                <td colspan="2"><strong>TOTAL AMOUNT</strong></td>
                <td class="text-right">
                  <strong>{{ getFinalTotal() | number: "1.2-2" }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Notes/Terms -->
        <div class="notes-section">
          <h3>Terms & Conditions</h3>
          <div *ngIf="customerDetails?.lpoTerms" class="custom-terms">
            {{ customerDetails.lpoTerms }}
          </div>
          <ul *ngIf="!customerDetails?.lpoTerms">
            <li>
              This Purchase Order is subject to the terms of service of
              ALUGULOO.
            </li>
            <li>Rental period and rates are as specified above.</li>
            <li>
              Vendor must ensure the equipment is in good working condition upon
              delivery.
            </li>
          </ul>
        </div>

        <!-- Footer Text -->
        <div class="footer-section" *ngIf="customerDetails?.lpoFooter">
          <p>{{ customerDetails.lpoFooter }}</p>
        </div>

        <!-- Signature Section -->
        <div class="signature-section">
          <div class="sig-block customer-block" style="margin-left: auto">
            <!-- 1. View Mode (Vendor OR Generated OR Signature exists) -->
            <ng-container *ngIf="
                customerDetails?.signatureUrl ||
                  customerDetails?.signatureBase64;
                else noSig
              ">
              <div class="signature-display">
                <img [src]="
                    customerDetails.signatureBase64 ||
                    customerDetails.signatureUrl
                  " alt="Authorized Signature" />
                <!-- Delete Button (Only for Customer & Not Generated) -->
                <button *ngIf="!isVendor && !data.booking.lpoGenerated" mat-icon-button color="warn"
                  class="no-print delete-sig-btn" (click)="
                    customerDetails.signatureUrl = undefined;
                    customerDetails.signatureBase64 = undefined
                  ">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <div class="sig-box">
                <div class="line"></div>
                <p>Customer Authorized Signature</p>
              </div>
            </ng-container>

            <!-- 2. Edit Mode (Customer & Not Generated & No Signature) -->
            <ng-template #noSig>
              <div class="signature-controls no-print" *ngIf="!isVendor && !data.booking.lpoGenerated; else blankSig">
                <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms">
                  <mat-tab label="Upload Image">
                    <div class="upload-tab" style="padding: 20px; text-align: center">
                      <button mat-stroked-button color="primary" (click)="triggerSigInput()">
                        <mat-icon>upload</mat-icon> Upload Signature Image
                      </button>
                      <input type="file" id="lpoSigInput" (change)="onSigSelected($event)" accept="image/*" hidden />
                      <p class="hint" style="font-size: 11px; color: #666; margin-top: 5px">
                        Transparent PNG recommended.
                      </p>
                    </div>
                  </mat-tab>
                  <mat-tab label="Draw Signature">
                    <div class="draw-tab" style="padding: 10px">
                      <div class="canvas-wrapper" style="
                          border: 1px solid #ccc;
                          background: #fff;
                          cursor: crosshair;
                        ">
                        <canvas #sigCanvas width="300" height="120" (mousedown)="startDrawing($event)"
                          (mousemove)="draw($event)" (mouseup)="stopDrawing()" (mouseleave)="stopDrawing()">
                        </canvas>
                      </div>
                      <div class="canvas-actions" style="
                          margin-top: 10px;
                          display: flex;
                          gap: 10px;
                          justify-content: center;
                        ">
                        <button mat-button color="warn" (click)="clearCanvas()">
                          Clear
                        </button>
                        <button mat-raised-button color="primary" (click)="saveCanvasSignature()">
                          Use Signature
                        </button>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </ng-template>

            <!-- 3. Blank/Fallback (If no sig and vendor viewing) -->
            <ng-template #blankSig>
              <div class="sig-box">
                <div class="line"></div>
                <p>Customer Authorized Signature</p>
              </div>
            </ng-template>
          </div>

          <!-- ── DIGITAL SIGNATURE SEAL ── -->
          <!-- Shown once the LPO has been generated/sent -->
          <div class="digital-seal" *ngIf="data.booking.lpoGenerated || digitalSignature">
            <div class="seal-header">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#10b981" width="14" height="14" style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
              </svg>
              <span class="seal-title">Digitally Signed</span>
            </div>
            <div class="seal-body">
              <div class="seal-row">
                <span class="seal-label">Signed By</span>
                <span class="seal-value">{{
                  customerDetails?.companyName || customerDetails?.name || 'Customer'
                  }}</span>
              </div>
              <div class="seal-row">
                <span class="seal-label">Date & Time</span>
                <span class="seal-value">{{
                  digitalSignature?.signedAt | date: 'dd MMM yyyy, HH:mm'
                  }}</span>
              </div>
              <div class="seal-row">
                <span class="seal-label">Reference</span>
                <span class="seal-value">{{ data.booking.lpoNumber || data.booking.id.slice(-6).toUpperCase() }}</span>
              </div>
            </div>
          </div>

          <!-- ── DIGITAL CONSENT CHECKBOX ── -->
          <!-- Shown only to customer before LPO is sent -->
          <div class="digital-consent-block" *ngIf="!isVendor && !data.booking.lpoGenerated && !isSample">
            <label class="consent-label" (click)="toggleConsent()">
              <div class="consent-checkbox" [class.checked]="consentGiven">
                <mat-icon *ngIf="consentGiven">check</mat-icon>
              </div>
              <span class="consent-text">
                I, <strong>{{ customerDetails?.companyName || 'the customer' }}</strong>,
                confirm that the above purchase order details are accurate and I authorise
                the submission of this LPO to the vendor. By ticking this box
                I agree that this constitutes a legally binding digital declaration
                on behalf of my company.
              </span>
            </label>
            <p class="consent-hint" *ngIf="!consentGiven">
              <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle">info</mat-icon>
              You must agree to the declaration above before sending the LPO.
            </p>
          </div>

          <!-- Printed consent confirmation — only visible after LPO is sent -->
          <div class="digital-consent-printed" *ngIf="data.booking.lpoGenerated && consentRecord">
            <mat-icon class="consent-print-icon">how_to_reg</mat-icon>
            <div>
              <p class="consent-print-title">Customer Declaration</p>
              <p class="consent-print-body">
                {{ consentRecord.customerName }} has confirmed that the details in this
                LPO are accurate and authorised its submission on
                {{ consentRecord.agreedAt | date: 'dd MMM yyyy, HH:mm' }}.
              </p>
            </div>
          </div>

        </div>
      </div>
    </ng-template>
  </div>
  </ng-container>
</div>